<template>
  <div class="">
    <div class="top" ref="top">
      <div class="menu">
        <p @click="openpop()">
          <img src="../assets/home/menu.png" alt="" />
        </p>
        <p>
          <router-link to="/serchList"
            ><img src="../assets/home/serch.png" alt=""
          /></router-link>
        </p>
      </div>
      <router-link to="/">
        <div class="logo">
          <img src="../assets/home/logo.png" alt="" />
        </div>
      </router-link>
      <div class="address">
        <p><img src="../assets/home/address.png" alt="" /></p>
        <p @click="showPopup">{{ title }}</p>
        <p><img src="../assets/home/xia.png" alt="" /></p>
      </div>
    </div>

    <van-popup v-model="show" position="left">
      <div class="usermain">
        <!-- <div class="userbg">
					<p>
						<img src="http://pic4.zhimg.com/50/v2-848b1a190d937e270e8d062d00865493_hd.jpg" alt="">
					</p>
					<p @click="dologin()">
						请登录
					</p>
					先影藏登录后在显示
					<p>
						<span style="color: #000000;">欢迎您,热巴</span>
						<span @click="openuser()">个人中心</span>
					</p>
				</div> -->
        <div class="userlist">
          <ul>
            <li
              v-for="(item, index) in liList"
              :key="index"
              v-on:click="addClass(index)"
              v-bind:class="{ classred: index == current }"
            >
              <p>
                <router-link :to="item.url">{{ item.title }}</router-link>
              </p>
            </li>
          </ul>
        </div>
      </div>
    </van-popup>

    <!--地区遮罩层-->
    <div class="addreschose" v-if="addresPrp">
      <div class="addbox">
        <div class="addresS">
          <p>选择省站点</p>
          <ul>
            <div class="flex">
              <li
                v-for="(item, index) in treeList"
                :key="item.id"
                v-bind:class="{ blue: index == current1 }"
                @click="
                  clickItem(item.children, item.id, item.name, item.code, index)
                "
              >
                {{ item.name }}
              </li>
            </div>
          </ul>
        </div>
        <div class="addresS">
          <p>选择市站点</p>
          <ul>
            <div class="flex">
              <li
                v-for="(item, index) in twoData"
                :key="item.id"
                v-bind:class="{ blue1: index == current2 }"
                @click="clickItem1(item.id, item.name, item.code, index)"
              >
                {{ item.name }}
              </li>
            </div>
          </ul>
        </div>

        <div class="dbbtn">
          <p @click="hideaddreschose">取消</p>
          <p @click="successeaddreschose">确定</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import __Config from "../api/config";
export default {
  name: "Header",
  components: {},
  data() {
    return {
      active: 0,
      show: false,
      current: 0,
      current1: -1,
      current2: -1,
      addresPrp: false,
      liList: [
        {
          title: "首页",
          url: "./",
        },
        // {
        // 	title: '课程',
        // 	url: '/CourseMore'
        // },
        {
          title: "下载",
          url: "/Dowload",
        },
        {
          title: "课程体系",
          url: "/Courdesystem",
        },
        {
          title: "关于我们",
          url: "/Aboutme",
        },
      ],
      title: "", //站点名称
      siteId: 20, //站点ID
      code: 20,
      treeList: [], //一级列表
      twoData: [], //2级列表
    };
  },
  methods: {
    //点击一级
    clickItem(data, id, name, code, index) {
      this.siteId = id;
      this.title = name;
      this.code = code;
      this.twoData = data;
      this.current2 = -1;
      this.current1 = index;
    },
    //点击二级
    clickItem1(id, name, code, index) {
      this.siteId = id;
      this.title = name;
      this.code = code;
      this.current2 = index;
    },
    openpop() {
      this.show = true;
    },
    addClass: function (index) {
      this.current = index;
    },
    //打开区域遮罩
    showPopup() {
      this.addresPrp = true;
    },
    hideaddreschose() {
      this.current1 = -1;
      this.current2 = -1;
      this.title = "全国";
      let obj = {
        id: 20,
        name: "全国",
        code: 20,
      };

      this.$store.commit("treeData", obj);
      this.addresPrp = false;
    },
    //确定
    successeaddreschose() {
      let obj = {
        id: this.siteId,
        name: this.title,
        code: this.code,
      };
      this.$store.commit("treeData", obj);
      //this.getinfioo();
      this.addresPrp = false;
    },

    //个人中心
    openuser() {
      this.$router.push({
        path: "/Usercenter",
        name: "",
        params: {
          key: "key",
        },
      });
    },
    //去登录
    dologin() {
      this.$router.push({
        path: "/Logo",
      });
    },
    //获取站点
    getTree() {
      var that = this;
      this.$axios
        .get(__Config.api.gettree, {
          params: {
            siteId: 0,
          },
        })
        .then(function (res) {
          (that.title = res.data.data[0].name),
            (that.siteId = res.data.data[0].id),
            (that.treeList = res.data.data[0].children);
          let obj = {
            id: res.data.data[0].id,
            name: res.data.data[0].name,
            code: res.data.data[0].code,
          };
          that.$store.commit("treeData", obj);
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    //招聘信息
    // getinfioo(){
    //      var that = this;
    // 	this.$axios.get(__Config.api.getexam,{
    // 		params: {
    // 			siteCode:this.code,
    // 			siteId:this.siteId
    // 		}
    // 	})
    // 	.then(function (res) {
    // 		 console.log(res.data.data[0].children);
    // 	     let  moduleId = res.data.data[0].moduleId;
    // 	   //数据
    // 	   that.$store.commit('examDatas',res.data.data[0].children);
    // 	   //去获取模块信息
    // 	   that.getmoduleCode(moduleId);
    // 	})
    // 	.catch(function (err) {
    // 		console.log(err);
    // 	});
    // },

    //根据招聘信息 ID 获取moduleCode
    // getmoduleCode(id){ //
    //     //储存 招聘信息模块id
    // 	  var that = this;
    // 		this.$axios.get(__Config.api.getmodule,{
    // 			params: {
    // 				moduleId:id
    // 			}
    // 		})
    // 		.then(function (res) {
    // 			    // console.log(res.data.data.code)
    // 				// console.log(res.data.data.id)
    // 				let obj={
    // 					moduleId:res.data.data.id,
    // 					moduleCode:res.data.data.code,
    // 				}
    // 		  that.$store.commit('moduleIdfn',obj);
    // 		})
    // 		.catch(function (err) {
    // 			console.log(err);
    // 		});
    // },
  },
  created() {
    this.getTree();
    //this.getinfioo();
  },
};
</script>

<style scoped>
.classred {
  background: #007ccf;
  color: #fff !important;
}
.blue {
  background: rgba(0, 124, 207, 1);
  color: #fff;
}
.blue1 {
  background: rgba(0, 124, 207, 1);
  color: #fff;
}
.usermain {
  width: 260px;
  height: 100%;
  background: #fff;
}

.userbg {
  width: 200px;
  height: 100px;
  position: relative;
}

.userbg p:nth-child(1) {
  width: 60px;
  height: 60px;
  margin: 13px;
}

.userbg p:nth-child(1) img {
  width: 100%;
  height: 100%;
  border-radius: 100%;
}

.userbg p:nth-child(2) {
  line-height: 30px;
  color: #007ccf;
  position: absolute;
  top: 13px;
  left: 85px;
  width: 135px;
  height: 30px;
  /* display: none; */
}

/*登陆后在显示*/
.userbg p:nth-child(3) {
  font-size: 14px;
  color: #666;
  color: #007ccf;
  position: absolute;
  top: 13px;
  left: 85px;
  width: 135px;
  height: 40px;
  display: none;
}

.userbg p:nth-child(3) span {
  display: block;
}

.userlist ul li {
  height: 50px;
  line-height: 50px;
  border-bottom: 1px solid #ccc;
}

.userlist ul li p {
  width: 100%;
  height: 100%;
  margin-left: 10px;
  font-size: 15px;
  font-weight: 300;
  line-height: 50px;
}

.userlist ul li p a {
  width: 100%;
  height: 100%;
  color: #333;
  display: inline-block;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue